module.exports = __webpack_public_path__ + "img/AboutUs.bbd5631b.jpg";